import {Component, OnInit} from '@angular/core';
import {Route, Router} from "@angular/router";
import {getPageChildRoutes} from "./routing/dynamic-routing.module";
import {ProfilesRootPageComponent} from "./pages/profiles/profiles-root-page.component";
import {ProfilesPageComponent} from "./pages/profiles/profiles-page.component";
import {LogsRootPageComponent} from "./pages/logs/logs-root-page.component";
import {LogsPageComponent} from "./pages/logs/logs-page.component";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';


  constructor(private router:Router) {

  }


  ngOnInit(): void {
    // put right after 1st entry
    const routes: Route = <Route>this.router.config[1];

    routes.children.splice(2, 0, {
      path: "profiles",
      data: { name: "Профайлы" },
      component: ProfilesRootPageComponent,
      children: getPageChildRoutes(ProfilesPageComponent)
    });

    /*routes.children.splice(2, 0, {
      path: "logs",
      data: { name: "Логи" },
      component: LogsRootPageComponent,
      children: getPageChildRoutes(LogsPageComponent)
    });*/

    /*routes.children.splice(2, 0, {
      path: "stats",
      data: { name: "Статистика" },
      component: LogsRootPageComponent,
      children: getPageChildRoutes(LogsPageComponent)
    });*/
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/app.component.ts